import React, { useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';
import { api } from '../../context/AuthContext';
import { toast } from 'sonner';

const fehler = (e) => toast.error(e?.response?.data?.detail || 'Aktion fehlgeschlagen');

export const Loeschkonzept = () => {
  const [d, setD] = useState(null);
  const laden = () => api.get('/kanzlei/loeschkonzept').then((r) => setD(r.data)).catch(fehler);
  useEffect(() => { laden(); }, []);
  if (!d) return null;
  const speichern = () => api.put('/kanzlei/loeschkonzept', { tage: d.tage, auto: d.auto }).then(() => { toast.success('Löschfristen gespeichert'); laden(); }).catch(fehler);
  const lauf = () => window.confirm('Löschlauf jetzt ausführen? Die Einträge der Vorschau werden endgültig gelöscht.') &&
    api.post('/kanzlei/loeschkonzept/lauf').then((r) => { toast.success(`Gelöscht: ${Object.values(r.data.ergebnis).reduce((a, b) => a + b, 0)} Einträge`); laden(); }).catch(fehler);
  const summe = d.kategorien.reduce((a, k) => a + k.anzahl, 0);
  return (
    <div className="space-y-3" data-testid="loeschkonzept">
      {d.kategorien.map((k) => (
        <div key={k.key} className="flex flex-wrap items-center gap-3 text-[13px]" data-testid={`loeschfrist-${k.key}`}>
          <span className="flex-1 min-w-[220px] text-[#1B3A5C]">{k.label}</span>
          <input type="number" min={7} max={3650} value={d.tage[k.key]} onChange={(e) => setD({ ...d, tage: { ...d.tage, [k.key]: Number(e.target.value) } })}
            className="w-24 h-9 px-3 rounded-[10px] border border-gray-200 focus:outline-none focus:border-[#1B3A5C]" data-testid={`loeschfrist-tage-${k.key}`} /> Tage
          <span className="w-40 text-xs text-gray-500" title={k.beispiele.join(', ')} data-testid={`loeschfrist-anzahl-${k.key}`}>Vorschau: {k.anzahl} fällig</span>
        </div>
      ))}
      <label className="flex items-center gap-2 text-[13px] text-[#1B3A5C]">
        <input type="checkbox" checked={d.auto} onChange={(e) => setD({ ...d, auto: e.target.checked })} className="accent-[#b8893d]" data-testid="loeschkonzept-auto" /> Täglicher automatischer Löschlauf (03:00 Uhr) freigegeben
      </label>
      <div className="flex flex-wrap gap-2 pt-1">
        <button type="button" onClick={speichern} className="h-9 px-4 rounded-[10px] bg-[#1B3A5C] hover:bg-[#15304d] text-white text-[13px]" data-testid="loeschkonzept-speichern">Speichern</button>
        <button type="button" onClick={lauf} disabled={!summe} className="h-9 px-4 rounded-[10px] border border-rose-200 text-rose-700 text-[13px] inline-flex items-center gap-2 disabled:opacity-40" data-testid="loeschkonzept-lauf"><Trash2 className="w-4 h-4" /> Löschlauf jetzt ({summe})</button>
      </div>
      {d.protokoll.length > 0 && <p className="text-xs text-gray-500" data-testid="loeschkonzept-letzter">Letzter Lauf: {new Date(d.protokoll[0].am).toLocaleString('de-DE')} · {d.protokoll[0].von}</p>}
    </div>
  );
};
